<template>
  <div class="dropdown-container" ref="dropdownContainer">
    <!-- 選択肢のラベル -->
    <div
      class="custom-select"
      :class="{
        disabled: isDisabled,
        active: isOpen,
        selected: !!modelValue,
        'is-missing': isMissing,
      }"
      tabindex="0"
      @click="toggleDropdown"
    >
      <span class="selected-option">{{ selectedLabel }}</span>
      <!-- 矢印アイコン -->
      <span class="dropdown-arrow"></span>
    </div>

    <!-- ドロップダウンオプション -->
    <div v-if="isOpen && !isDisabled" class="dropdown-options" ref="dropdownOptions">
      <div
        v-for="option in options"
        :key="option.label"
        :class="{ 'color-dropdown': option.isColor,
          'selected-option': modelValue === option.label
        }"
        class="option"
        @click="selectOption(option)"
      >
        <!-- モバイル用の色アイコン -->
        <!-- <div
          v-if="isMobile"
          class="color-icon"
          :style="{ backgroundColor: getColor(option.label) }"
        ></div> -->

        <!-- 768px以下の場合は横並び表示にする -->
        <div v-if="isMobile" class="option-row">
          <!-- 左側：ラジオボタン & ラベル -->
          <div class="option-row-left">
            <input
              class="custom-dropdown__radio"
              type="radio"
              :value="option.label"
              :checked="modelValue === option.label"
              @change="selectOption(option)"
            />
            <span class="option-label">{{ option.displayLabel || option.label }}</span>
          </div>

          <!-- 真ん中：color-icon（カラーアイコン） -->
          <div v-if="option.isColor" class="option-row-center">
            <div
              class="color-icon"
              :style="{ backgroundColor: getColor(option.label) }"
            ></div>
          </div>

          <!-- 右側：バックスタイル -->
          <div
            v-if="label === 'バックスタイル' && option.image"
            class="option-row-right"
          >
            <img
              :src="option.image"
              :alt="`${option.label}のサンプル`"
              class="font-style-sample"
            />
          </div>

          <!-- 右側：背面ひも通し -->
          <div
            v-if="label === '背面ひも通し' && option.image"
            class="option-row-right"
          >
            <img
              :src="option.image"
              :alt="`${option.label}のサンプル`"
              class="font-style-sample"
            />
          </div>

          <!-- 右側：背面ひも通し -->
          <div
            v-if="label === 'トジ部' && option.image"
            class="option-row-right"
          >
            <img
              :src="option.image"
              :alt="`${option.label}のサンプル`"
              class="font-style-sample"
            />
          </div>

          <!-- 右側：フォント画像(書体) -->
          <div v-if="label === '書体' && option.image" class="option-row-right">
            <img
              :src="option.image"
              :alt="`${option.label}のサンプル`"
              class="font-style-sample"
            />
          </div>
        </div>

        <!-- PC向け(768px以上)では今まで通り label だけを表示する例 -->
        <div v-else class="option-row-pc">
          <!-- ラジオボタンはPCでも出したいならここに -->
          {{ option.displayLabel || option.label }}
        </div>

        <!-- モバイル版で説明文を表示 -->
        <div v-if="isMobile && option.description" class="option-description">
          {{ option.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomDropdown",
  props: {
    label: String,
    options: {
      type: Array,
      required: true, // 選択肢を必須に設定
    },
    modelValue: {
      type: String,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false, // デフォルトは有効
    },
    dropdownId: {
      // 新しく追加
      type: String,
      required: false,
    },
    missingFields: {
      type: Array,
      default: () => [],
    },
    // ドロップダウンそれぞれの「キー」を受け取っておく
    dropdownKey: {
      type: String,
      required: true,
    },
  },
  emits: ["update:modelValue", "update:isOpen", "change"],
  data() {
    return {
      isOpen: false,
      isMobile: false, // モバイル判定
    };
  },

  computed: {
    selectedLabel() {
      // modelValue が存在すればその値、なければ label を表示？
      // (実装はお好みでOK)
      return this.modelValue || this.label;
    },
    // missingFields の中に自分の dropdownKey があれば「未選択扱い」
    isMissing() {
      // ドロップダウンが無効化されている場合は、未選択扱いにしない
      if (this.isDisabled) return false;
      // modelValue が存在すれば選択済み、そうでなければ missingFields に含まれているかをチェック
      return !this.modelValue && this.missingFields.includes(this.dropdownKey);
    },
  },

  mounted() {
    this.isMobile = window.innerWidth <= 768; // 初回モバイル判定
    window.addEventListener("resize", this.checkMobile); // リサイズ時の判定
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    toggleDropdown() {
      if (!this.isDisabled) {
        console.log("111");
        this.isOpen = !this.isOpen;
        this.$emit("update:isOpen", this.isOpen); // ドロップダウン状態を親に通知
      }

        console.log("222");
    },

   
    // scrollDropdownIntoViewIfNeeded() {
    //   const dropdownEl = this.$refs.dropdownOptions;
    //   const leftSideEl = this.$refs.leftSide;

    //   // 両方とも取れないと動かせない
    //   if (!dropdownEl || !leftSideEl) return;

    //   // left-side 全体と ドロップダウン要素 のそれぞれの位置情報
    //   const leftSideRect = leftSideEl.getBoundingClientRect();
    //   const dropdownRect = dropdownEl.getBoundingClientRect();

    //   // ドロップダウンの「上端」と left-side の「上端」の距離
    //   // つまり「left-side内でドロップダウンがどこにあるか」を計算
    //   let offset = dropdownRect.top - leftSideRect.top;

    //   // 固定ヘッダー分 or 余白を足したい場合: 例で80px分引き算
    //   const headerOffset = 80;
    //   offset -= headerOffset;

    //   // scrollTop を「今のスクロール位置 + offset」ぶん動かす
    //   leftSideEl.scrollTo({
    //     top: leftSideEl.scrollTop + offset,
    //     behavior: "smooth",
    //   });
    // },

    selectOption(option) {
      if (!this.isDisabled) {
        this.$emit("update:modelValue", option.label); // 選択された値を親に渡す
        this.$emit("change", option.label);
        // this.isOpen = false;
        // this.$emit("update:isOpen", this.isOpen); // ドロップダウン閉じる状態を通知
        // 同じ選択肢をもう一度クリックしたら閉じる
        if (this.modelValue === option.label) {
          this.isOpen = false;
          this.$emit("update:isOpen", this.isOpen);
        }
      }
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    closeDropdown() {
      this.isOpen = false;
      // this.$emit("update:isOpen", this.isOpen);
    },
    resetDropdown() {
      this.closeDropdown();
    },

    getColor(label) {

      const translationMap = {
        "ブラック": "blk",
        "ネイビー": "nvy",
        "ブルー": "blu",
        "サックス": "sax",
        "オレンジ": "orn",
        "Dオレンジ": "dor",
        "レッド": "red",
        "ピンク": "pnk",
        "パープル": "ppl",
        "レモン": "lmn",
        "コルク": "crk",
        "チョコ": "cho",
        "グリーン": "grn",
        "Mグリーン": "mgn",
        "グレー": "gry",
        "ホワイト": "wht",
        "キャメル": "cml",
        "シルバー": "sil",
        "ゴールド": "gld",

        //特殊カラー
        "イエロー": "ylw",
        "中白ブラック": "wbk",
        "ミズイロ": "sbu",
        "中白パープル": "wpl",
        "中白チョコ": "wch",
        "Lゴールド": "lgd",
        "Rピンク": "rpk",
        "Sピンク": "spk",
        "Lイエロー": "lyw",
        "Lグリーン": "lgn",
        "Lシルバー": "lsl",
        "エンジ": "enj",
      };

      const key = translationMap[label] || label;
      const colorMap = {
        blk: "#050711",
        nvy: "#272263",
        blu: "#283890",
        sax: "#00AEF0",
        orn: "#F1592B",
        dor: "#F03F36",
        red: "#EE1C25",
        pnk: "#ED008D",
        ppl: "#92288F",
        lmn: "#F6EE31",
        crk: "#8C5E3C",
        cho: "#603813",
        grn: "#046939",
        mgn: "#00A197",
        gry: "#808285",
        wht: "#FFFFFF",
        cml: "#FFE294",
        sil: "#949599",
        gld: "#FCB040",

        // 特殊カラー例（必要なら残す/削る）
        ylw: "#FFCA30",
        wbk: "#050711",
        sbu: "#0089D0",
        wpl: "#92288F",
        wch: "#603813",
        lgd: "#FCB040",
        rpk: "#ED008D",
        spk: "#F499C2",
        lyw: "#EAD539",
        lgn: "#8DC73F",
        lsl: "#949599",
        // sil: "#BBBDC0",
        // gld: "#FDBF68",
        銀糸: "#BBBDC0",
        金糸: "#FDBF68",
        enj: "#9D0917",
      };

      // もしラベルが存在しない場合は白を返す
      return colorMap[key] || "#FFFFFF";
    },
    updateValue(newValue) {
      this.$emit("input", newValue); // v-model の値を更新
    },
  },
};
</script>

<style scoped>
.custom-select.disabled {
  pointer-events: none; /* クリック操作を無効化 */
  opacity: 0.5; /* 見た目を無効化 */
}

.option.selected-option {
  background-color: #666 !important;
  color: white !important;
}
/* モバイル用の色アイコン */
.selected-option {
  /* white-space: nowrap;
  overflow-x: auto; */
}

.font-style-sample {
  width: 100%; /* 必要に応じて調整 */
  max-width: 120px;
  height: auto;
  margin-top: 10px; /* 上部に余白を追加 */
  display: block; /* ブロック要素として表示 */
}
.is-missing {
  /* 未選択の場合、赤背景 */
  background-color: red;
  color: #fff;
}

.custom-dropdown__radio {
  display: none; /* デフォルトでラジオボタンを非表示 */

  @media screen and (max-width: 768px) {
    display: inline-block; /* 768px以下でラジオボタンを表示 */
    margin-right: 8px;
  }
}


@media (max-width: 768px) {
  .color-dropdown .costom-dropdown-sp-flex {
    display: flex;
    align-items: center; /* 垂直方向に中央揃え */
    justify-content: space-between; /* 水平方向にスペースを分配 */
  }

  .color-dropdown .costom-dropdown-sp-flex-l {
    display: flex;
    align-items: center;
    flex: 1; /* 残りのスペースを占有 */
    padding-left: 10px;
  }

  .color-dropdown .costom-dropdown-sp-flex-r {
    display: flex;
    align-items: center;
    flex: 0 0 auto; /* コンテンツのサイズに応じて */
    margin-left: 10px; /* 左側にスペースを追加 */
  }

  .option-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* 必要なら幅100%固定などを指定してもOK */
  }

  .option-row-left {
    display: flex;
    align-items: center;
    /* 必要に応じて margin や padding を設定 */
  }

  .option-row-left .custom-dropdown__radio {
    display: inline-block; /* 768px以下でラジオ表示 */
    margin-right: 8px;
  }

  .option-row-center {
    margin-left: 8px; /* 少し離しておく */
    display: flex;
    align-items: center;
    justify-content: center; /* 真ん中寄せしたい場合 */
  }

  .option-row-right {
    margin-left: auto; /* 右端へ寄せる */
    display: flex;
    align-items: center;
  }

  /* カラーアイコン */
  .color-icon {
    width: 16px;
    height: 16px;
    border: 1.5px solid #fff;
  }

  /* 画像サンプル */
  .font-style-sample {
    max-width: 80px;
    height: auto;
    display: block;
    margin-top: 0; /* 不要なら削除 */
  }

  /* 説明文は下に出したいから block で幅100%使う感じに */
  .option-description {
    display: block;
    margin-top: 4px;
    font-size: 0.9rem;
    color: gray;
    white-space: pre-wrap;
  }
  .is-missing {
    /* 未選択の場合、赤背景 */
    background-color: red;
    color: #fff;
  }
}
</style>
